analytics.eventConfig.push(
    {
    "target": ".nav-header",
    "events": [
        {
            "eventTarget": ".search-button-header",
            "eventType": "click",
            "tags": {
                "event": "onsite search",
                "componentName": "coveo search box",
                "componentId": "csb",
                "eventType": "search submit",
                "elementType": "search box",
                "parentName": "",
                "searchTerm": "",
                "searchType": ""
            }
        },
        {
            "eventTarget": ".search-textbox-header",
            "eventType": "SearchButtonText",
            "tags": {
                "event": "onsite search",
                "componentName": "coveo search box",
                "componentId": "csb",
                "eventType": "search submit",
                "elementType": "search box",
                "parentName": "",
                "searchTerm": "",
                "searchType": ""
            }
        }
    ]
},
{
    "target": ".nav-header .nav-wrapper",
    "codeId": "hlr14",
    "events": [
        {
            "eventTarget": "a.nav-main-item.nav-main-search-trigger",
            "eventType": "click",
            "tags": {
                "event": "navigation",
                "componentName": "header",
                "componentId": "hlr14",
                "eventType": [
                    {
                        "rule": "$(context).attr('class') === 'nav-main-item nav-main-search-trigger nav-main-item-active'",
                        "value": "header search expansion click"
                    },
                    {
                        "rule": "$(context).attr('class')  === 'nav-main-item nav-main-search-trigger'",
                        "value": "header search collapse click"
                    }
                ],
                "elementType": "icon",
                "elementText": "",
                "titleText": ""
            }
        }
    ]
},
{
    "target": ".nav-header.navbar-main-header .nav-wrapper",
    "codeId": "mm",
    "events": [
        {
            "eventTarget": ".nav-main-list-trigger",
            "eventType": "click",
            "tags": {
                "event": "navigation",
                "componentName": "mega menu",
                "componentId": "mm",
                "parentName": "header",
                "elementType": "hamburger",
                "eventType": [
                    {
                        "rule": "$('html').hasClass('nav-main-mobile-open')",
                        "value": "hamburger expansion click"
                    },
                    {
                        "rule": "true",
                        "value": "hamburger collapse click"
                    }
                ]
            }
        },
        {
            "eventTarget": ".nav-meganav-wrapper a:not([href*=\\http]):not('.linknavigation')",
            "eventType": "click",
            "tags": {
                "event": [
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                        "value": "contact"
                    },
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').search(new RegExp('pdf|xls|xlsx|doc|docx', 'i')) > -1",
                        "value": "download"
                    },
                    {
                        "rule": "true",
                        "value": "navigation"
                    }
                ],
                "componentName": "mega menu",
                "componentId": "mm",
                "destinationUrl": "",
                "parentName": "header",
                "elementText": "",
                "eventType": [
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                        "value": "click to email"
                    },
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').search(new RegExp('pdf|xls|xlsx|doc|docx', 'i')) > -1",
                        "value": "other media asset click"
                    },
                    {
                        "rule": "$(context).parents('.meganav-subitem-container').siblings('.nav-expandable-menu').length > 0",
                        "value": "mega menu sub internal navigation click"
                        //"value": "mega menu dropdown internal navigation click"
                    },
                    {
                        "rule": "$(context).attr('data-menu-level') == '2'",
                        "value": "mega menu internal navigation click"
                    },
                    {
                        "rule": "true",
                        "value": "mega menu sub internal navigation click"
                    }

                ],
                "elementType": "mega menu link",
                "fileName": "",
                "parentTitle": "",
                "parentListSource": "",
            }
        },
        {
            "eventTarget": ".nav-meganav-wrapper a[href*=\\http]:not('.linknavigation')",
            "eventType": "click",
            "tags": {
                "event": [
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pds') !== -1 || $(context).attr('href').toLowerCase().search('psims') !== -1)",
                        "value": "download"
                    },
                    {
                        "rule": "true",
                        "value": "outbound"
                    }
                ],
                "componentName": "mega menu",
                "componentId": "mm",
                "destinationUrl": "",
                "parentName": "header",
                "elementText": "",
                "eventType": [
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('pds') !== -1 ",
                        "value": "pds download click"
                    },
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('psims') !== -1",
                        "value": "sds download click"
                    },
                    {
                        "rule": "$(context).parents('.meganav-subitem-container').siblings('.nav-expandable-menu').length > 0",
                        "value": "mega menu sub outbound click"
                        //"value": "mega menu dropdown outbound click"
                    },
                    {
                        "rule": "$(context).attr('data-menu-level') == '2'",
                        "value": "mega menu outbound click"
                    },
                    {
                        "rule": "true",
                        "value": "mega menu sub outbound click"
                    }
                ],
                "elementType": "mega menu link",
                "fileName": "",
                "parentTitle": "",
                "parentListSource": "",
            }
        },
        {
            "eventTarget": ".nav-meganav .linknavigation[href]",
            "eventType": "click",
            "tags": {
                "event": [
                    {
                        "rule": "$(context).prop('hostname') !== window.location.hostname",
                        "value": "outbound"
                    },
                    {
                        "rule": "true",
                        "value": "navigation"
                    }
                ],
                "componentName": "mega menu",
                "componentId": "mm",
                "destinationUrl": "",
                "parentName": "header",
                "elementText": "",
                "eventType": [
                    {
                        "rule": "$(context).prop('hostname') !== window.location.hostname",
                        "value": "mega menu title outbound click"
                    },
                    {
                        "rule": "true",
                        "value": "mega menu title link internal navigation click"
                    }
                ],
                "elementType": "mega menu link",
                "parentListSource": "",
            }
        },
        {
            "eventTarget": ".dropdown-menu.show a:not([href*=\\http]):not('.linknavigation')",
            "eventType": "click",
            "tags": {
                "event": [
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                        "value": "contact"
                    },
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').search(new RegExp('pdf|xls|xlsx|doc|docx', 'i')) > -1",
                        "value": "download"
                    },
                    {
                        "rule": "true",
                        "value": "navigation"
                    }
                ],
                "componentName": "mega menu",
                "componentId": "mm",
                "destinationUrl": "",
                "parentName": "header",
                "elementText": "",
                "eventType": [
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                        "value": "click to email"
                    },
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').search(new RegExp('pdf|xls|xlsx|doc|docx', 'i')) > -1",
                        "value": "other media asset click"
                    },
                    {
                        "rule": "$(context).parents('.nav-expandable-menu-open').length",
                        "value": "mega menu sub internal navigation click"
                        //"value": "mega menu dropdown internal navigation click"
                    },
                    {
                        "rule": "$(context).parent('.nav-meganav-subitem').length>0",
                        "value": "mega menu sub internal navigation click"
                    },
                    {
                        "rule": "$(context).parent('.nav-meganav-title').hasClass('nav-meganav-subitem').length==0",
                        "value": "mega menu internal navigation click"
                    },
                    {
                        "rule": "true",
                        "value": "mega menu internal navigation click"
                    }
                ],
                "elementType": "mega menu link",
                "fileName": "",
                "parentTitle": "",
                "parentListSource": "",
            }
        },
        {
            "eventTarget": ".dropdown-menu.show a[href*=\\http]:not('.linknavigation')",
            "eventType": "click",
            "tags": {
                "event": [
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pds') !== -1 || $(context).attr('href').toLowerCase().search('psims') !== -1)",
                        "value": "download"
                    },
                    {
                        "rule": "true",
                        "value": "outbound"
                    }
                ],
                "componentName": "mega menu",
                "componentId": "mm",
                "destinationUrl": "",
                "parentName": "header",
                "elementText": "",
                "eventType": [
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('pds') !== -1 ",
                        "value": "pds download click"
                    },
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('psims') !== -1",
                        "value": "sds download click"
                    },
                    {
                        "rule": "$(context).parents('.nav-expandable-menu-open').length",
                        "value": "mega menu sub outbound click"
                        //"value": "mega menu dropdown outbound click"
                    },
                    {
                        "rule": "$(context).parent('.nav-meganav-subitem').length>0",
                        "value": "mega menu sub outbound click"
                    },
                    {
                        "rule": "$(context).parent('.nav-meganav-title').hasClass('nav-meganav-subitem').length==0",
                        "value": "mega menu outbound click"
                    },
                    {
                        "rule": "true",
                        "value": "mega menu outbound click"
                    }
                ],
                "elementType": "mega menu link",
                "fileName": "",
                "parentTitle": "",
                "parentListSource": "",
            }
        },
        {
            "eventTarget": ".dropdown-menu.show .linknavigation[href]",
            "eventType": "click",
            "tags": {
                "event": [
                    {
                        "rule": "$(context).prop('hostname') !== window.location.hostname",
                        "value": "outbound"
                    },
                    {
                        "rule": "true",
                        "value": "navigation"
                    }
                ],
                "componentName": "mega menu",
                "componentId": "mm",
                "destinationUrl": "",
                "parentName": "header",
                "elementText": "",
                "eventType": [
                    {
                        "rule": "$(context).prop('hostname') !== window.location.hostname",
                        "value": "mega menu title outbound click"
                    },
                    {
                        "rule": "true",
                        "value": "mega menu title link internal navigation click"
                    }
                ],
                "elementType": "mega menu link",
                "parentListSource": "",
            }
        },
    ]
},
{
    "target": "#nav-main-mobile",
    "codeId": "mm",
    "events": [
        {
            "eventTarget": "ul.nav-main-mobile-panel a:not([href^=\\#],[href*=\\http]):not('.linknavigation'):not([data-menu-level=1])",
            "eventType": "click",
            "tags": {
                "event": [
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').search(new RegExp('^mailto:', 'i')) > -1",
                        "value": "contact"
                    },
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').search(new RegExp('pdf|xls|xlsx|doc|docx', 'i')) > -1",
                        "value": "download"
                    },
                    {
                        "rule": "true",
                        "value": "navigation"
                    }
                ],
                "componentName": "mega menu",
                "componentId": "mm",
                "destinationUrl": "",
                "parentName": "header",
                "elementText": "",
                "eventType": [
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                        "value": "click to email"
                    },
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').search(new RegExp('pdf|xls|xlsx|doc|docx', 'i')) > -1",
                        "value": "other media asset click"
                    },
                    {
                        "rule": "$(context).attr('data-menu-level') == '2'",
                        "value": "mega menu internal navigation click"
                    },
                    {
                        "rule": "true",
                        "value": "mega menu sub internal navigation click"
                    }
                ],
                "elementType": "mega menu link",
                "fileName": "",
                "parentTitle": "",
                "parentListSource": "",
            }
        },
        {
            "eventTarget": "ul.nav-main-mobile-panel a[href*=\\http]:not('.linknavigation'):not([data-menu-level=1])",
            "eventType": "click",
            "tags": {
                "event": [
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pds') !== -1 || $(context).attr('href').toLowerCase().search('psims') !== -1)",
                        "value": "download"
                    },
                    {
                        "rule": "true",
                        "value": "outbound"
                    }
                ],
                "componentName": "mega menu",
                "componentId": "mm",
                "destinationUrl": "",
                "parentName": "header",
                "elementText": "",
                "eventType": [
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('pds') !== -1 ",
                        "value": "pds download click"
                    },
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('psims') !== -1",
                        "value": "sds download click"
                    },
                    {
                        "rule": "$(context).attr('data-menu-level') == '2'",
                        "value": "mega menu outbound click"
                    },
                    {
                        "rule": "true",
                        "value": "mega menu sub outbound click"
                    }
                ],
                "elementType": "mega menu link",
                "fileName": "",
                "parentTitle": "",
                "parentListSource": "",
            }
        },
        {
            "eventTarget": ".nav-main-mobile-back .linknavigation[href]",
            "eventType": "click",
            "tags": {
                "event": [
                    {
                        "rule": "$(context).prop('hostname') !== window.location.hostname",
                        "value": "outbound"
                    },
                    {
                        "rule": "true",
                        "value": "navigation"
                    }
                ],
                "componentName": "mega menu",
                "componentId": "mm",
                "destinationUrl": "",
                "parentName": "header",
                "elementText": "",
                "eventType": [
                    {
                        "rule": "$(context).prop('hostname') !== window.location.hostname",
                        "value": "mega menu title outbound click"
                    },
                    {
                        "rule": "true",
                        "value": "mega menu title link internal navigation click"
                    }
                ],
                "elementType": "mega menu link",
                "parentListSource": "",
            }
        },
    ]
},
{
    "target": ".nav-header.icon-nav-header .nav-main-bar",
    "codeId": "mni",
    "events": [
        {
            "eventTarget": ".nav-main-item.nav-icon-trigger",
            "eventType": "click",
            "tags": {
                "event": "navigation",
                "componentName": "mega nav with icons",
                "componentId": "mni",
                "eventType": [
                    {
                        "rule": "$(context).closest('a.nav-main-item.nav-icon-trigger.nav-main-item-active').length",
                        "value": "hamburger expansion click"
                    },
                    {
                        "rule": "$(context).closest('a.nav-main-item.nav-icon-trigger.nav-main-item-active').length==0",
                        "value": "hamburger collapse click"
                    },
                ],
                "elementType": "hamburger",
                "parentName": "header"
            }
        },
        {
            "eventTarget": ".dropdown-menu.show a:not([href*=\\http]):not('.linknavigation')",
            "eventType": "click",
            "tags": {
                "event": [
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                        "value": "contact"
                    },
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                        "value": "download"
                    },
                    {
                        "rule": "true",
                        "value": "navigation"
                    }
                ],
                "componentName": "mega nav with icons",
                "componentId": "mni",
                "parentName": "header",
                "elementText": "",
                "fileName": "",
                "destinationUrl": "",
                "eventType": [
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                        "value": "click to email"
                    },
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                        "value": "other media asset click"
                    },
                    {
                        "rule": "$(context).parents('.nav-expandable-menu-open').length",
                        "value": "mega nav icons sub internal navigation click"
                    },
                    {
                        "rule": "$(context).children('.nav-link-icon').length",
                        "value": "mega nav icons internal navigation click"
                    },
                    {
                        "rule": "$(context).closest('.show').hasClass('hasIconPadding')|| $(context).closest('.show').hasClass('noIconPadding')",
                        "value": "mega nav icons sub internal navigation click"
                    },
                    {
                        "rule": "true",
                        "value": "mega nav icons internal navigation click"
                    }
                ],
                "elementType": "mega nav icon",
                "parentTitle": "",
                "parentListSource": "",
            }
        },
        {
            "eventTarget": ".dropdown-menu.show a[href*=\\http]:not('.linknavigation')",
            "eventType": "click",
            "tags": {
                "event": [
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pds') !== -1 || $(context).attr('href').toLowerCase().search('psims') !== -1)",
                        "value": "download"
                    },
                    {
                        "rule": "true",
                        "value": "outbound"
                    }
                ],
                "componentName": "mega nav with icons",
                "componentId": "mni",
                "parentName": "header",
                "fileName": "",
                "destinationUrl": "",
                "elementText": "",
                "eventType": [
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('pds') !== -1 ",
                        "value": "pds download click"
                    },
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('psims') !== -1",
                        "value": "sds download click"
                    },
                    {
                        "rule": "$(context).children('.nav-link-icon').length",
                        "value": "mega nav icons outbound click"
                    },
                    {
                        "rule": "$(context).parents('.nav-expandable-menu-open').length",
                        "value": "mega nav icons sub outbound click"
                    },
                    {
                        "rule": "$(context).closest('.show').hasClass('hasIconPadding')|| $(context).closest('.show').hasClass('noIconPadding')",
                        "value": "mega nav icons sub outbound click"
                    },
                    {
                        "rule": "true",
                        "value": "mega nav icons outbound click"
                    },
                ],
                "parentTitle": "",
                "parentListSource": "",
                "elementType": "mega nav icon"
            }
        },
        {
            "eventTarget": ".dropdown-menu.show .linknavigation[href]",
            "eventType": "click",
            "tags": {
                "event": [
                    {
                        "rule": "$(context).prop('hostname') !== window.location.hostname",
                        "value": "outbound"
                    },
                    {
                        "rule": "true",
                        "value": "navigation"
                    }
                ],
                "componentName": "mega nav with icons",
                "componentId": "mni",
                "destinationUrl": "",
                "parentName": "header",
                "elementText": "",
                "eventType": [
                    {
                        "rule": "$(context).prop('hostname') !== window.location.hostname",
                        "value": "mega nav icons title outbound click"
                    },
                    {
                        "rule": "true",
                        "value": "mega nav icons title link internal navigation click"
                    }
                ],
                "elementType": "mega nav icon",
                "parentListSource": "",
            }
        },
        {
            "eventTarget": ".dropdown-menu.show .contains-nav-chat .nav-chat a.nav-chat-trigger", //nav-chat? dropdown menu jest w left-nav, nav-icons, nav-main, nav-meganav, nav-serlector-language
            "eventType": "click",
            "tags": {
                "event": [
                    {
                        "rule": "true",
                        "value": "navigation"
                    }
                ],
                "componentName": "mega nav with icons",
                "componentId": "mni",
                "parentName": "header",
                "fileName": "",
                "destinationUrl": "",
                "elementText": "",
                "eventType": [
                    {
                        "rule": "true",
                        "value": "mega nav icons internal navigation click"
                    }
                ],
                "elementType": "mega nav icon"
            }
        }
    ]
},
{
    "target": ".nav-header .nav-main-bar .nav-main-list",
    "codeId": "mmtnl",
    "events": [
        {
            // "contact us" in nav
            "eventTarget": ".nav-main-item a:not([href=\\#])",
            "eventType": "click",
            "tags": {
                "componentId": "mmtnl",
                "componentName": "mega menu top nav link",
                "destinationUrl": "",
                "elementText": "",
                "eventType": [
                    {
                        "rule": "$(context).prop('hostname') !== window.location.hostname",
                        "value": "mega menu top nav outbound click"
                    },
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                        "value": "other media asset click"
                    },
                    {
                        "rule": "true",
                        "value": "mega menu top nav internal navigation click"
                    }
                ],
                "event": [
                    {
                        "rule": "$(context).prop('hostname') !== window.location.hostname",
                        "value": "outbound"
                    },
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                        "value": "download"
                    },
                    {
                        "rule": "true",
                        "value": "navigation"
                    }
                ],
                "elementType": "mega menu top nav link",
                "parentName": "header",
                "fileName": "",
            }
        }
    ]
},
{
    "target": ".nav-header .nav-wrapper", 
    "codeId": "wll",
    "events": [
        {
            "eventTarget": "ul.component.link-list.nav-lines-brands a:not([href*=\\http])",
            "eventType": "click",
            "tags": {
                "componentId": "wll",
                "componentName": "wep link list",
                "destinationUrl": "",
                "elementText": "",
                "elementType": "wep link",
                "event": [
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                        "value": "contact"
                    },
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                        "value": "download"
                    },
                    {
                        "rule": "true",
                        "value": "navigation"
                    }
                ],
                "eventType": [
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                        "value": "click to email"
                    },
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                        "value": "other media asset click"
                    },
                    {
                        "rule": "true",
                        "value": "wep link internal navigation click"
                    }
                ],
                "parentName": "",
                "fileName": ""
            }
        },
        {
            "eventTarget": "ul.component.link-list.nav-lines-brands a[href*=\\http]",
            "eventType": "click",
            "tags": {
                "componentId": "wll",
                "componentName": "wep link list",
                "destinationUrl": "",
                "elementText": "",
                "elementType": "wep link",
                "event": [
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pds') !== -1 || $(context).attr('href').toLowerCase().search('psims') !== -1)",
                        "value": "download"
                    },
                    {
                        "rule": "true",
                        "value": "outbound"
                    }
                ],
                "eventType": [
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('pds') !== -1 ",
                        "value": "pds download click"
                    },
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('psims') !== -1",
                        "value": "sds download click"
                    },
                    {
                        "rule": "true",
                        "value": "wep link outbound click"
                    }
                ],
                "parentName": "",
                "fileName": ""
            }
        }
    ]
},
{
    "target": ".nav-top-bar-right",
    "codeId": "wll",
    "events": [
        {
            "eventTarget": "ul.component.link-list.nav-links-top-right a:not([href*=\\http])",
            "eventType": "click",
            "tags": {
                "componentId": "wll",
                "componentName": "wep link list",
                "destinationUrl": "",
                "elementText": "",
                "elementType": "wep link",
                "event": [
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                        "value": "contact"
                    },
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                        "value": "download"
                    },
                    {
                        "rule": "true",
                        "value": "navigation"
                    }
                ],
                "eventType": [
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                        "value": "click to email"
                    },
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                        "value": "other media asset click"
                    },
                    {
                        "rule": "true",
                        "value": "wep link internal navigation click"
                    }
                ],
                "parentName": "",
                "fileName": ""
            }
        },
        {
            "eventTarget": "ul.component.link-list.nav-links-top-right a[href*=\\http]",
            "eventType": "click",
            "tags": {
                "componentId": "wll",
                "componentName": "wep link list",
                "destinationUrl": "",
                "elementText": "",
                "elementType": "wep link",
                "event": [
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pds') !== -1 || $(context).attr('href').toLowerCase().search('psims') !== -1)",
                        "value": "download"
                    },
                    {
                        "rule": "true",
                        "value": "outbound"
                    }
                ],

                "eventType": [
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('pds') !== -1 ",
                        "value": "pds download click"
                    },
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('psims') !== -1",
                        "value": "sds download click"
                    },
                    {
                        "rule": "true",
                        "value": "wep link outbound click"
                    }
                ],
                "parentName": "",
                "fileName": ""
            }
        }
    ]
},
{
    "target": ".nav-header.icon-nav-header .nav-main-bar", 
    "codeId": "mtni",
    "events": [
        {
            "eventTarget": ".nav-link.dropdown-toggle[href*=\\http]",
            "eventType": "click",
            "tags": {
                "componentName": "mega top nav with icons",
                "componentId": "mtni",
                "eventType": [
                    {
                        "rule": "$(context).prop('hostname') !== window.location.hostname",
                        "value": "mega top nav icons outbound click"
                    },
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                        "value": "other media asset click"
                    },

                    {
                        "rule": "true",
                        "value": "mega top nav icons outbound click"
                    }
                ],
                "event": [
                    {
                        "rule": "$(context).prop('hostname') !== window.location.hostname",
                        "value": "outbound"
                    },

                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                        "value": "download"
                    },
                    {
                        "rule": "true",
                        "value": "navigation"
                    },
                ],
                "elementText": "",
                "elementType": "mega top nav icons link",
                "fileName": "",
                "parentName": "header",
                "parentTitle": "",
                "parentListSource": "",
                "destinationUrl": "",
            }
        },

        {
            "eventTarget": ".nav-link.dropdown-toggle:not([href*=\\http]):not([href*='javascript:void(0)']):not([href=\\#])",
            "eventType": "click",
            "tags": {
                "componentName": "mega top nav with icons",
                "componentId": "mtni",
                "eventType": [
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                        "value": "other media asset click"
                    },
                    {
                        "rule": "true",
                        "value": "mega top nav icons internal navigation click"
                    }

                ],
                "event": [
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                        "value": "download"
                    },
                    {
                        "rule": "true",
                        "value": "navigation"
                    },
                ],
                "elementText": "",
                "elementType": "mega top nav icons link",
                "parentName": "header",
                "fileName": "",
                "parentTitle": "",
                "parentListSource": "",
                "destinationUrl": "",
            }
        },
    ]
},
// /for withouticon pages following with icon structure/wholesale
// for direct link
{
    "target": ".nav-header.navbar-main-header .nav-main-bar",
    "codeId": "mmtnl",
    "events": [
        {
            "eventTarget": ".navbar-nav .nav-item>a[href*=\\http]",
            "eventType": "click",
            "tags": {
                "componentName": "mega menu top nav link",
                "componentId": "mmtnl",
                "eventType": [
                    {
                        "rule": "$(context).prop('hostname') !== window.location.hostname",
                        "value": "mega menu top nav outbound click"
                    },
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                        "value": "other media asset click"
                    },
                    {
                        "rule": "true",
                        "value": "mega menu top nav internal navigation click"
                    }

                ],
                "event": [
                    {
                        "rule": "$(context).prop('hostname') !== window.location.hostname",
                        "value": "outbound"
                    },
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                        "value": "download"
                    },
                    {
                        "rule": "true",
                        "value": "navigation"
                    },

                ],
                "elementText": "",
                "elementType": "mega menu top nav link",
                "parentName": "header",
                "parentTitle": "",
                "parentListSource": "",
                "destinationUrl": "",
                "fileName": "",
            }
        },
        {
            "eventTarget": ".navbar-nav .nav-item>a:not([href*=\\http]):not([href*='javascript:void(0)'])",
            "eventType": "click",
            "tags": {
                "componentName": "mega menu top nav link",
                "componentId": "mmtnl",
                "eventType": [
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                        "value": "other media asset click"
                    },
                    {
                        "rule": "true",
                        "value": "mega menu top nav internal navigation click"
                    }
                ],
                "event": [
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                        "value": "download"
                    },
                    {
                        "rule": "true",
                        "value": "navigation"
                    },
                ],
                "elementText": "",
                "elementType": "mega menu top nav link",
                "parentName": "header",
                "parentTitle": "",
                "parentListSource": "",
                "destinationUrl": "",
                "fileName": "",
            }
        },
    ]
},
//This is for menu without icons mobile view
{
    "target": "#mainmenu",
    "codeId": "mmtnl",
    "events": [
        {
            "eventTarget": "a[href*=\\http]",
            "eventType": "click",
            "tags": {
                "componentName": "mega menu top nav link",
                "componentId": "mmtnl",
                "eventType": [
                    {
                        "rule": "$(context).prop('hostname') !== window.location.hostname",
                        "value": "mega menu top nav outbound click"
                    },
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                        "value": "other media asset click"
                    },
                    {
                        "rule": "true",
                        "value": "mega menu top nav internal navigation click"
                    }
                ],
                "event": [
                    {
                        "rule": "$(context).prop('hostname') !== window.location.hostname",
                        "value": "outbound"
                    },
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                        "value": "download"
                    },
                    {
                        "rule": "true",
                        "value": "navigation"
                    },
                ],
                "elementText": "",
                "elementType": "mega menu top nav link",
                "parentName": "header",
                "parentTitle": "",
                "parentListSource": "",
                "destinationUrl": "",
                "fileName": "",
            }
        },
        {
            "eventTarget": "a:not([href^=\\#],[href*=\\http]):not([href*='javascript:void(0)'])",
            "eventType": "click",
            "tags": {
                "componentName": "mega menu top nav link",
                "componentId": "mmtnl",
                "eventType": [
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                        "value": "other media asset click"
                    },
                    {
                        "rule": "true",
                        "value": "mega menu top nav internal navigation click"
                    }
                ],
                "event": [
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                        "value": "download"
                    },
                    {
                        "rule": "true",
                        "value": "navigation"
                    },
                ],
                "elementText": "",
                "elementType": "mega menu top nav link",
                "parentName": "header",
                "parentTitle": "",
                "parentListSource": "",
                "destinationUrl": "",
                "fileName": "",
            }
        },
    ]
},
{
    "target": ".nav-top-bar-right",
    "codeId": "wll",
    "events": [
        {
            "eventTarget": "ul.component.link-list.nav-links-top-right a:not([href*=\\http])",
            "eventType": "click",
            "tags": {
                "componentId": "wll",
                "componentName": "wep link list",
                "destinationUrl": "",
                "elementText": "",
                "elementType": "wep link",
                "event": [
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                        "value": "contact"
                    },
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                        "value": "download"
                    },
                    {
                        "rule": "true",
                        "value": "navigation"
                    }
                ],
                "eventType": [
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                        "value": "click to email"
                    },
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                        "value": "other media asset click"
                    },
                    {
                        "rule": "true",
                        "value": "wep link internal navigation click"
                    }
                ],
                "parentName": "",
                "fileName": ""
            }
        },
        {
            "eventTarget": "ul.component.link-list.nav-links-top-right a[href*=\\http]",
            "eventType": "click",
            "tags": {
                "componentId": "wll",
                "componentName": "wep link list",
                "destinationUrl": "",
                "elementText": "",
                "elementType": "wep link",
                "event": [
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pds') !== -1 || $(context).attr('href').toLowerCase().search('psims') !== -1)",
                        "value": "download"
                    },
                    {
                        "rule": "true",
                        "value": "outbound"
                    }
                ],
                "eventType": [
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('pds') !== -1 ",
                        "value": "pds download click"
                    },
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('psims') !== -1",
                        "value": "sds download click"
                    },
                    {
                        "rule": "true",
                        "value": "wep link outbound click"
                    }
                ],
                "parentName": "",
                "fileName": ""
            }
        }
    ]
    },

    //analytics for footer goes here
    {
        "target": ".footer-top-wrapper",
        "events": [
            {

                "eventTarget": ".search-button",
                "eventType": "click",
                "tags": {
                    "event": "onsite search",
                    "componentName": "coveo search box",
                    "componentId": "csb",
                    "eventType": "search submit",
                    "elementType": "search box",
                    "parentName": "",
                    "searchTerm": "",
                    "searchType": ""
                }
            },

            {
                "eventTarget": ".search-bar-footer",
                "eventType": "SearchButtonText",
                "tags": {
                    "event": "onsite search",
                    "componentName": "coveo search box",
                    "componentId": "csb",
                    "eventType": "search submit",
                    "elementType": "search box",
                    "parentName": "",
                    "searchTerm": "",
                    "searchType": ""
                }
            }

        ]
    },
    {
        "target": ".footer-logos",
        "codeId": "fl",
        "events": [
            {
                "eventTarget": ".component.FooterLogos a:not([href*=\\http])",
                "eventType": "click",
                "tags": {
                    "componentId": "fl",
                    "componentName": "footer logo",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "footer logo",
                    "event": [

                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                            "value": "contact"
                        },
                        {
                            "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                            "value": "download"
                        },
                        {
                            "rule": "true",
                            "value": "navigation"
                        }
                    ],
                    "eventType": [
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                            "value": "click to email"
                        },
                        {
                            "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                            "value": "other media asset click"
                        },
                        {
                            "rule": "true",
                            "value": "footer logo internal navigation click"
                        },
                    ],
                    "parentName": "",
                    "fileName": ""
                }
            },
            {
                "eventTarget": ".component.FooterLogos a[href^=\\http]",
                "eventType": "click",
                "tags": {
                    "componentId": "fl",
                    "componentName": "footer logo",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "footer logo",
                    "componentType": "Footer",
                    "interactionType": "click",
                    "elementClicked": "logo",
                    "contentTitle": "",
                    "deviceType": "",
                    "event": [
                        {
                            "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pds') !== -1 || $(context).attr('href').toLowerCase().search('psims') !== -1)",
                            "value": "download"
                        },
                        {
                            "rule": "true",
                            "value": "outbound"
                        }
                    ],
                    "eventType": [
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('pds') !== -1 ",
                            "value": "pds download click"
                        },
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('psims') !== -1",
                            "value": "sds download click"
                        },
                        {
                            "rule": "true",
                            "value": "footer logo outbound click"
                        }
                    ],
                    "parentName": "",
                    "fileName": ""
                }
            }
        ]
    },
    {
        "target": ".footer-social .social-icons",
        "codeId": "si",
        "events": [
            {
                "eventTarget": "a:not([href^=\\#],[href*=\\http])",
                "eventType": "click",
                "tags": {
                    "componentId": "si",
                    "componentName": "social icon",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "social icon",
                    "event": [

                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                            "value": "contact"
                        },
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').search(new RegExp('pdf|xls|xlsx|doc|docx', 'i')) > -1",
                            "value": "download"
                        },
                        {
                            "rule": "true",
                            "value": "navigation"
                        }
                    ],
                    "eventType": [
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                            "value": "click to email"
                        },
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').search(new RegExp('pdf|xls|xlsx|doc|docx', 'i')) > -1",
                            "value": "other media asset click"
                        },
                        {
                            "rule": "true",
                            "value": "social icon internal navigation click"
                        }
                    ],
                    "parentName": "",
                    "fileName": ""
                }
            },
            {
                "eventTarget": "a[href*=\\http]",
                "eventType": "click",
                "tags": {
                    "componentId": "si",
                    "componentName": "social icon",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "social icon",
                    "componentType": "Footer",
                    "interactionType": "click",
                    "elementClicked": "logo",
                    "contentTitle": "",
                    "deviceType": "",
                    "event": [
                        {
                            "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pds') !== -1 || $(context).attr('href').toLowerCase().search('psims') !== -1)",
                            "value": "download"
                        },
                        {
                            "rule": "true",
                            "value": "outbound"
                        }
                    ],
                    "eventType": [
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('pds') !== -1 ",
                            "value": "pds download click"
                        },
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('psims') !== -1",
                            "value": "sds download click"
                        },
                        {
                            "rule": "true",
                            "value": "social icon outbound click"
                        }
                    ],
                    "parentName": "",
                    "fileName": ""
                }
            }
        ]
    },
    {
        "target": "#footer",
        "codeId": "wll",
        "events": [
            {
                "eventTarget": ".component.link-list.footer-links a:not(.ot-sdk-show-settings):not([href*='http'])",
                "eventType": "click",
                "tags": {
                    "componentId": "wll",
                    "componentName": "wep link list",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "wep link",
                    "event": [
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                            "value": "contact"
                        },
                        {
                            "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                            "value": "download"
                        },
                        {
                            "rule": "true",
                            "value": "navigation"
                        }
                    ],

                    "eventType": [
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                            "value": "click to email"
                        },
                        {
                            "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                            "value": "other media asset click"
                        },
                        {
                            "rule": "true",
                            "value": "wep link internal navigation click"
                        }
                    ],
                    "parentName": "",
                    "fileName": ""
                }
            },
            {
                "eventTarget": ".component.link-list.footer-links a.ot-sdk-show-settings:not([href*=\\http])",
                "eventType": "mousedown",
                "tags": {
                    "componentId": "wll",
                    "componentName": "wep link list",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "wep link",
                    "event": [
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                            "value": "contact"
                        },
                        {
                            "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                            "value": "download"
                        },
                        {
                            "rule": "true",
                            "value": "navigation"
                        }
                    ],

                    "eventType": [
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                            "value": "click to email"
                        },
                        {
                            "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                            "value": "other media asset click"
                        },
                        {
                            "rule": "true",
                            "value": "wep link internal navigation click"
                        }
                    ],
                    "parentName": "",
                    "fileName": ""
                }
            },
            {
                 "eventTarget": ".component.link-list.footer-links a.ot-sdk-show-settings:not([href*=\\http])",
                "eventType": "keydown",
                "tags": {
                    "componentId": "wll",
                    "componentName": "wep link list",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "wep link",
                    "event": [
                        {
                            "rule": "event.key === 'Enter' && $(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                            "value": "contact"
                        },
                        {
                            "rule": "event.key === 'Enter' && $(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                            "value": "download"
                        },
                        {
                            "rule": "event.key === 'Enter'",
                            "value": "navigation"
                        }
                    ],

                    "eventType": [
                        {
                            "rule": "event.key === 'Enter' && $(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                            "value": "click to email"
                        },
                        {
                            "rule": "event.key === 'Enter' && $(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                            "value": "event.key === 'Enter' && other media asset click"
                        },
                        {
                            "rule": "event.key === 'Enter'",
                            "value": "wep link internal navigation click"
                        }
                    ],
                    "parentName": "",
                    "fileName": ""
                }
            },
            {
                "eventTarget": ".component.link-list.footer-links a[href*=\\http]",
                "eventType": "click",
                "tags": {
                    "componentId": "wll",
                    "componentName": "wep link list",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "wep link",
                    "componentType": "Footer",
                    "interactionType": "click",
                    "elementClicked": "link",
                    "contentTitle": "",
                    "deviceType": "",
                    "event": [
                        {
                            "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pds') !== -1 || $(context).attr('href').toLowerCase().search('psims') !== -1)",
                            "value": "download"
                        },
                        {
                            "rule": "true",
                            "value": "outbound"
                        }
                    ],

                    "eventType": [
                        {

                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('pds') !== -1 ",
                            "value": "pds download click"
                        },
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('psims') !== -1",
                            "value": "sds download click"
                        },
                        {
                            "rule": "true",
                            "value": "wep link outbound click"
                        }
                    ],
                    "parentName": "",
                    "fileName": ""
                }
            }
        ]
    },
    {
        "target": "div.component.logo",
        "codeId": "wl",
        "events": [{

            "eventTarget": "div.component-content a",
            "eventType": "click",
            "tags": {
                "componentId": "wl",
                "componentName": "wep logo",
                "destinationUrl": "",
                "elementText": "",
                "elementType": "wep logo",
                "event": [
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                        "value": "contact"
                    },
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pds') !== -1 || $(context).attr('href').toLowerCase().search('psims') !== -1)",
                        "value": "download"
                    },
                    {
                        "rule": "$(context).prop('hostname') !== window.location.hostname",
                        "value": "outbound"
                    },
                    {
                        "rule": "true",
                        "value": "navigation"
                    }
                ],
                "eventType": [
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                        "value": "click to email"
                    },
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                        "value": "other media asset click"
                    },
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('pds') !== -1 ",
                        "value": "pds download click"
                    },
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('psims') !== -1",
                        "value": "sds download click"
                    },
                    {
                        "rule": "$(context).prop('hostname') !== window.location.hostname",
                        "value": "wep logo outbound click"
                    },
                    {
                        "rule": "true",
                        "value": "wep logo internal navigation click"
                    }
                ],
                "parentName": "",
                "fileName": ""
            }
        }
        ]
    },
);

